import { EntityTypes } from "./enums";

export interface PlatformMetrics {
    metricId: string;
    date: number;
    entityType: EntityTypes.platformMetrics;
    activeUsers: number;
    activeSuppliers: number;
    intakeCompleted: number;
    assessmentsCompleted: number;
    scheduledGrowthPlanSession?: number;
    completedGrowthPlanSession?: number;
    growthPlansGenerated: number;
    platformUsage: number;
}